<div class="pdf-preview-step-popup">
  <div class="container-fluid">
    <div class="row" *ngFor="let row of htmlStructure">
      <div *ngFor="let element of row.columns;let index=index;"
        [class]="'align-self-end col-' + element.numberOfColumn">
        <div [ngSwitch]="element.fieldType">
          <div *ngSwitchCase="'partTitle'">
            <span class="part-title">{{ element.elementTitle }}</span>
          </div>
          <div *ngSwitchCase="'subHeadingTitle'">
            <span class="sub-head-title">{{ element.elementTitle }}</span>
          </div>
          <div *ngSwitchCase="'Questionnaire'">
            <div class="form-group clearfix">
              <label class="questionnaire-lbl">{{ element.elementTitle }}</label>
              <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
            </div>
          </div>
          <div *ngSwitchCase="'switchWithExp'">
            <div class="form-group clearfix">
              <label class="questionnaire-lbl">{{ element.elementTitle }}</label>
              <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
            </div>
            <div class="form-group">
              <label class="d-block">{{ element.textAreaLabel }}</label>
              <textarea class="json-viewer-textarea" [disabled]="true" pInputTextarea></textarea>
            </div>
          </div>
          <div *ngSwitchCase="'textarea'">
            <div class="form-group">
              <label class="d-block">{{ element.elementTitle }}</label>
              <textarea class="json-viewer-textarea" pInputTextarea></textarea>
            </div>
          </div>
          <div *ngSwitchCase="'Textbox'">
            <div class="form-group">
              <label class="d-block">{{ element.elementTitle }}</label>
              <input type="text" pInputText />
            </div>
          </div>
          <div *ngSwitchCase="'checkboxWithHeader'">
            <div class="form-group">
              <label class="d-block" *ngIf="element.elementTitle && element.elementTitle.length > 0">{{
                element.elementTitle }}</label>
              <div class="clearfix">
                <p-checkbox class="pdf-checkbox" *ngFor="let props of element.properties" [label]="props.name">
                </p-checkbox>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'Checkbox'">
            <div class="form-group clearfix">
              <p-checkbox class="pdf-checkbox" *ngFor="let props of element.properties" [label]="props.name">
              </p-checkbox>
            </div>
          </div>
          <div *ngSwitchCase="'elementHeading'">
            <span class="element-head-title">{{ element.elementTitle }}</span>
          </div>
          <div *ngSwitchCase="'Dropdown'">
            <div class="form-group">
              <label class="d-block">{{ element.elementTitle }}</label>
              <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="element.properties">
              </p-dropdown>
            </div>
          </div>
          <div *ngSwitchCase="'CALENDAR'">
            <div class="form-group">
              <label class="d-block">{{ element.elementTitle }}</label>
              <p-calendar appendTo="body" styleClass="vd-pdf-datepicker preview" dateFormat="mm/dd/yy"
                placeholder="MM/DD/YYYY" [showIcon]="true" [monthNavigator]="true"
                [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
              </p-calendar>
            </div>
          </div>
          <div *ngSwitchCase="'Radiobutton'">
            <div class="form-group">
              <label class="d-block" *ngIf="element.elementTitle && element.elementTitle.length > 0">{{
                element.elementTitle }}</label>
              <div class="clearfix">
                <p-radioButton class="mb-2 pdf-radiobutton" *ngFor="let props of element.properties; let y = index;"
                  [(ngModel)]="element.radioValue" [value]="element.groupName + '_' + y"
                  [label]="props.name"></p-radioButton>
              </div>
            </div>
          </div>
          <div *ngSwitchCase="'countryState'">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label class="d-block">Country</label>
                  <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="countryList"
                    optionLabel="name" optionValue="code" (onChange)="handleCountryChange($event, element)">
                  </p-dropdown>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label class="d-block">State</label>
                  <input type="text"
                    *ngIf="!element.stateList || (element.stateList && element.stateList.length === 0)"
                    pInputText class="json-viewer-input" placeholder="Enter" />
                  <p-dropdown appendTo="body" *ngIf="element.stateList && element.stateList.length > 0"
                    optionLabel="stateProvinceName" optionValue="stateProvinceCode"
                    styleClass="pdf-dropdown" [options]="element.stateList">
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div *ngSwitchDefault>
            <span style="font-weight:600;color:red;">Default</span> {{
            element.fieldType }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <p-divider type="dashed"></p-divider>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <button pButton label="Save" title="Save" icon="pi pi-save" class="save-btn mr-3 float-left"></button>
        <button pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times-circle" class="cancel-btn
            float-left">
        </button>
      </div>
      <div class="col-md-4">
        <button pButton type="button" label="Mark Complete" title="Mark Complete" icon="pi pi-times-circle"
          class="mark-complete button-width-icon-left">
        </button>
      </div>
    </div>
  </div>
</div>
